import {
  QueryKey,
  useQueryClient,
  InvalidateQueryFilters,
} from "@tanstack/react-query";
import { useCallback } from "react";

export const useCustomInvalidate = () => {
  const queryClient = useQueryClient();

  const customInvalidate = useCallback(
    async (
      queryKey: string | string[] | QueryKey,
      options?: Partial<InvalidateQueryFilters>
    ) => {
      return queryClient.invalidateQueries({
        queryKey: Array.isArray(queryKey) ? queryKey : [queryKey],
        ...options,
      });
    },
    [queryClient]
  );

  return { customInvalidate };
};
